import { NgModule }     from '@angular/core';
import { CommonModule } from '@angular/common';

// Modules
import { SharedModule } from 'src/app/shared/shared.module';

// Component generator
import { ComponentSelectorComponent }     from './component-generator/component-selector/component-selector.component';
import { CardsTopImageListComponent }     from './component-generator/components/cards-top-image-list/cards-top-image-list.component';
import { CardsLateralImageListComponent } from './component-generator/components/cards-lateral-image-list/cards-lateral-image-list.component';
import { FaqQuestionsComponent }          from './component-generator/components/faq-questions/faq-questions.component';
import { HtmlTextComponent }              from './component-generator/components/html-text/html-text.component';
import { HtmlTextListComponent }          from './component-generator/components/html-text-list/html-text-list.component';
import { ImageCarouselComponent }         from './component-generator/components/image-carousel/image-carousel.component';
import { VideoFrameComponent }            from './component-generator/components/video-frame/video-frame.component';

// Components
import { HeaderMenuComponent }      from './components/header-menu/header-menu.component';
import { FooterMenuComponent }      from './components/footer-menu/footer-menu.component';
import { SponsorsToolbarComponent } from './components/sponsors-toolbar/sponsors-toolbar.component';

// Elements
import { HeaderComponent }      from './elements/header/header.component';
import { FooterComponent }      from './elements/footer/footer.component';
import { NewsletterComponent }  from './elements/newsletter/newsletter.component';
import { SpinnerComponent }     from './elements/spinner/spinner.component';
import { SpinnerMainComponent } from './elements/spinner-main/spinner-main.component';

// Pages
import { MainComponent }         from './pages/main/main.component';
import { NotAvailableComponent } from './pages/not-available/not-available.component';
import { NotFoundComponent }     from './pages/not-found/not-found.component';

@NgModule({

    declarations: [

        ComponentSelectorComponent,
        CardsTopImageListComponent,
        CardsLateralImageListComponent,
        FaqQuestionsComponent,
        HtmlTextComponent,
        HtmlTextListComponent,
        ImageCarouselComponent,
        VideoFrameComponent,

        HeaderMenuComponent,
        FooterMenuComponent,
        SponsorsToolbarComponent,

        HeaderComponent,
        FooterComponent,
        NewsletterComponent,
        SpinnerComponent,

        MainComponent,
        NotAvailableComponent,
        NotFoundComponent,
        SpinnerMainComponent

    ],

    imports: [
        CommonModule,
        SharedModule
    ],

    exports: [
        ComponentSelectorComponent,
        SpinnerComponent,
        SpinnerMainComponent,
        MainComponent,
        NotAvailableComponent,
        NotFoundComponent
    ]
    
})
export class WebTemplateModule { }
